query UserOrganizationsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: OrganizationUsersFilterInput
) {
  organizationUsers(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      roles
      organization {
        id
        title
      }
      createdAt
    }
    count
  }
}
